import script from "./PaymentsPageCreatorPaymentsReceivedTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentsPageCreatorPaymentsReceivedTab.vue?vue&type=script&setup=true&lang=js"

import "./PaymentsPageCreatorPaymentsReceivedTab.vue?vue&type=style&index=0&id=194ed63d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-194ed63d"]])

export default __exports__